import React from "react";
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Aboutus.css";
import home from '../assets/images/home.png'
import bannerImage from '../assets/images/HomePageBanner.webp';
import aboutUsVideo from "../assets/videos/About Us.mp4";



const Aboutus = () => {

    const teamMembers = [
        {
            name: "John Doe",
            role: "CEO",
            img: home,
            socials: {
                facebook: "#",
                twitter: "#",
                linkedin: "#",
                whatsapp: "#",
                youtube: "#"
            }
        },
        {
            name: "Jane Smith",
            role: "CTO",
            img: home,
            socials: {
                facebook: "#",
                twitter: "#",
                linkedin: "#",
                whatsapp: "#",
                youtube: "#"
            }
        },
        {
            name: "Michael Brown",
            role: "Marketing Head",
            img: home,
            socials: {
                facebook: "#",
                twitter: "#",
                linkedin: "#",
                whatsapp: "#",
                youtube: "#"
            }
        }
    ];
    return (
        <>
            {/* Banner Section */}

            <div className=' home-container1'>
                <div
                    className="banner-section"
                    style={{ backgroundImage: `url(${bannerImage})` }}
                >
                    <div className="banner-overlay"></div>
                    <div className="banner-content">
                        <h1>End Land Investment Uncertainties with <br />India's First Legal-Verified Plots Marketplace</h1>
                        <p className="breadcrumb-text">
                            {/* <span></span> */}
                        </p>
                    </div>
                </div>
            </div>

            <section className="light-section">
                <div className="video-container">
                    <video
                        src={aboutUsVideo}
                        controls
                        autoPlay={true}
                        muted
                        loop
                    />
                </div>
            </section>

            <section className="vision-mission-cards">
                <div className="vm-card">
                    <div className="vm-icon">↗</div>
                    <h3>Our Vision</h3>
                    <p>
                        <b>“To become India’s most trusted and intelligent platform for land investment—where every plot is verified, every buyer is protected, and every decision is backed by legal and data-driven clarity.”</b><br />
                        We envision a future where buying land is no longer a gamble but a transparent, secure, and informed process. Our goal is to eliminate land fraud and empower individuals and families—across cities and rural India alike—to invest in plots with absolute confidence, backed by both expert due diligence and predictive AI insights.

                    </p>
                </div>

                <div className="vm-card">
                    <div className="vm-icon">↗</div>
                    <h3>Our Mission</h3>
                    <p>
                        <b>
                            “To safeguard land investors by offering expert-led plot verification,
                            ongoing legal protection, and intelligent tools that help assess future
                            value and area development—making land investment secure, simple, and
                            strategic.”
                        </b>
                    </p>

                    <p><b>At PlotsVerified, our mission is to:</b></p>
                    <ul>
                        <li>Make professional plot verification accessible to everyone through a structured, tech-enabled process.</li>
                        <li>Leverage the expertise of legal consultants and ex-Mandal Revenue Officers to ensure authenticity and compliance.</li>
                        <li>Offer post-verification legal support so buyers are protected beyond the transaction.</li>
                        <li>Use AI to analyze infrastructure trends and provide reliable projections of land appreciation.</li>
                        <li>Build trust in land transactions, one verified plot at a time.</li>
                    </ul>
                </div>


            </section>
            <section className="story-section">
                <div className="story-left">
                    <h2>A Legacy of <span>Trust, Transparency, and Protection</span></h2>
                    <p>
                        It started with a story we’ve all heard too often—someone bought a plot with dreams of
                        building a home or securing their future, only to later discover the land was entangled
                        in a legal dispute, falsely claimed, or not even registered in the seller’s name.
                    </p>
                    <p>
                        One of our founders witnessed this heartbreak up close when a close friend lost lakhs of
                        rupees on a plot that seemed “clean” on paper, but turned out to be part of a multi-party
                        dispute. Despite filing a complaint, the legal process dragged on for years. No real help
                        came from agents or brokers, and most victims just gave up, accepting their loss.
                    </p>
                    <p>
                        That incident exposed a deep flaw in the land-buying process: lack of accessible,
                        trustworthy due diligence. Real estate is still largely unregulated at the grassroots
                        level, and buyers are left vulnerable in a system filled with misinformation, loopholes,
                        and fraudulent documentation.
                    </p>
                    <p>
                        We created PlotsVerified to fix that. By bringing together veteran legal consultants and
                        former Mandal Revenue Officers—people who have worked inside the system—we decided to
                        create a platform that puts transparency, accountability, and legal safety at the center
                        of land investment. Not only do we verify every plot through exhaustive legal and field
                        checks, but we also go a step further by offering 1-year free legal protection
                        post-verification.
                    </p>
                    <p>
                        Today, PlotsVerified isn’t just a service—it’s a mission to protect land buyers from
                        fraud and empower them with tools to make informed, confident decisions. With the
                        addition of AI-powered insights on area development and long-term value, we’re combining
                        human expertise and technology to revolutionize the way India invests in land.
                    </p>
                </div>

                <div className="story-right">
                    <div className="story-card">
                        <div className="story-icon">↗</div>
                        <h3>5000+</h3>
                        <p>Plots Verified</p>
                    </div>

                    <div className="story-card">
                        <div className="story-icon">↗</div>
                        <h3>3000+</h3>
                        <p>Happy Customers</p>
                    </div>

                    <div className="story-card">
                        <div className="story-icon">↗</div>
                        <h3>100+</h3>
                        <p>Expert Legal Consultants</p>
                    </div>

                    <div className="story-card">
                        <div className="story-icon">↗</div>
                        <h3>1 Year</h3>
                        <p>Free Legal Protection</p>
                    </div>
                </div>
            </section>
            <section className="team-section">
                <h2 className="team-title">Our Team</h2>

                <div className="team-member">
                    <div className="team-photo">
                        <img src={bannerImage} alt="John Doe" />
                    </div>
                    <div className="team-info">
                        <h3>John Doe</h3>
                        <h4>Strategic Growth Advisor</h4>
                        <p>
                            John brings decades of expertise in land investment strategy,
                            legal compliance, and digital transformation. He plays a key
                            role in shaping PlotsVerified’s vision for safe and transparent land buying.
                        </p>
                        <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="linkedin-link">
                            <i className="fab fa-linkedin"></i> ↗
                        </a>
                    </div>
                </div>

                <div className="team-member">
                    <div className="team-photo">
                        <img src={bannerImage} alt="Jane Smith" />
                    </div>
                    <div className="team-info">
                        <h3>Jane Smith</h3>
                        <h4>VP - Legal & Compliance</h4>
                        <p>
                            Jane has over 20 years of experience in real estate law and compliance,
                            ensuring that every plot verified by PlotsVerified meets the highest
                            standards of authenticity and safety.
                        </p>
                        <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="linkedin-link">
                            <i className="fab fa-linkedin"></i> ↗
                        </a>
                    </div>
                </div>

                <div className="team-member">
                    <div className="team-photo">
                        <img src={bannerImage} alt="Michael Brown" />
                    </div>
                    <div className="team-info">
                        <h3>Michael Brown</h3>
                        <h4>Director - Technology</h4>
                        <p>
                            Michael drives innovation at PlotsVerified by integrating AI and
                            advanced tech tools that analyze growth patterns and land appreciation
                            trends for smarter investments.
                        </p>
                        <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="linkedin-link">
                            <i className="fab fa-linkedin"></i> ↗
                        </a>
                    </div>
                </div>
            </section>

        </>
    );
};

export default Aboutus;
